import React from "react";
import { Compass } from "lucide-react";

export default function NorthCompass({ heading }) {
  const rotation = Number.isFinite(heading) ? heading : 0;

  return (
    <div className="pointer-events-none absolute right-3 top-[4.75rem] z-[940] md:right-5 md:top-20">
      <div className="pointer-events-auto flex h-11 w-11 flex-col items-center justify-center rounded-full border border-white/70 bg-white/95 shadow-xl shadow-black/20 backdrop-blur-xl dark:border-cyan-100/20 dark:bg-slate-950/95 md:h-16 md:w-16">
        <div className="text-[8px] font-black leading-none text-red-600 md:text-[10px]">N</div>
        <Compass className="mt-0.5 h-5 w-5 text-slate-900 dark:text-white md:h-7 md:w-7" style={{ transform: `rotate(${rotation}deg)` }} />
      </div>
    </div>
  );
}